import { IonCard } from "@ionic/react";
import { forwardRef } from "react";
import { cx } from "@/lib/style/cva.config";

export const FriendCheckCard = forwardRef<HTMLIonCardElement, React.ComponentProps<typeof IonCard>>(
	function FriendCheckQuestionCard(props, ref) {
		return (
			<IonCard
				ref={ref}
				{...props}
				className={cx(
					"text-brown-700 ion-bg-brown-100 part-native:flex part-native:flex-col part-native:justify-between m-0 flex flex-col justify-between rounded-2xl px-4 py-3 shadow-none",
					!!props.onClick && "ion-activatable cursor-pointer",
					props.className,
				)}
			>
				{props.children}
			</IonCard>
		);
	},
);
